import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { putData } from "../../../utils/api";
import CareerFields, { ImageField, buildCareerFormData, useCareerOptions } from "./CareerFields";

// Always returns plain text, even when the API sends back a database error object
const messageOf = (res) => {
  if (res?.success) return typeof res?.message === "string" ? res.message : "Saved";
  const e = res?.errors ?? res?.message;
  if (typeof e === "string") return e;
  return (
    e?.original?.sqlMessage ||
    e?.parent?.sqlMessage ||
    e?.message ||
    (typeof res?.message === "string" ? res.message : "") ||
    "Something went wrong"
  );
};

const EditOffCanvance = (props) => {
  const id = props.show; // Tables.js passes the career id as `show`
  const { getData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const { options, today } = useCareerOptions();

  const {
    control,
    register,
    handleSubmit,
    trigger,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const f = { control, register, trigger, errors };

  useEffect(() => {
    (async () => {
      const response = await getData(`/admin/career/career-form/${id}`);
      const d = response?.data;
      if (!d) return;
      reset({
        ...d,
        // <input type="date"> needs YYYY-MM-DD
        deadline: d.deadline ? String(d.deadline).slice(0, 10) : "",
      });
    })();
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const response = await putData(`/admin/career/career-form/${id}`, buildCareerFormData(data));
      const ok = !!response?.success;
      setShowModal({ code: response?.code, message: messageOf(response) });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (ok) props.handleClose(); // stay open on error so nothing typed is lost
      }, ok ? 1000 : 3500);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Edit Career</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <CareerFields f={f} options={options} today={today}>
              <ImageField register={register} value={watch("image")} />
            </CareerFields>
            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link>
                  <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                </Link>
                <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default EditOffCanvance;